import "../../vendor/js/waapi-animate-details";
(function ($, window, document) {
	/**
	 *
	 *   ... code in here will run after jQuery says document is ready
	 */
	$(function () {
		// * Function to automatically open an accordion if a hash is in the URL
		let accordion_hash_handler = {
			_init: function () {
				// check for accordions
				let $accordions = $(".wp-block-nu-blocks-accordion");

				// check for hash value
				let $hash = window.location.hash;

				// bail early
				if ($accordions.length == 0 || $hash.length == 0) {
					return;
				}

				// * Get the accordion item with the hash above
				let anchor = $(".wp-block-nu-blocks-accordion-item" + $hash);

				// * Exit the function if there is no accordion item with this hash
				if (anchor.length == 0) {
					return;
				}

				// * Otherwise click open the element's summary with this hash
				$(anchor).siblings().find("details").removeAttr("open");
				$(anchor).find("details").attr("open", "open");

				let $offset =
					$(anchor).find("details").offset().top - $("header").height();
				$(window).scrollTop($offset);
			},
		};

		$(window).on("hashchange load", function () {
			accordion_hash_handler._init();
		});

		// * Expand / collapse every accordion in scope
		let accordion_toggle_all = {
			labelOpen: "Expand all",
			labelClose: "Collapse all",

			_init: function () {
				$(".accordion-toggle-all").each(function () {
					let wrapper = this;

					// The core button block renders the control as an inner <a>
					let control = wrapper.querySelector("a") || wrapper;

					// Scope to the containing accordion block if the button sits
					// inside one, otherwise control every accordion on the page
					let $scope = $(wrapper).closest(".wp-block-nu-blocks-accordion");
					if ($scope.length === 0) {
						$scope = $(document);
					}

					let $details = $scope.find(
						".wp-block-nu-blocks-accordion-item details"
					);

					if ($details.length === 0) {
						return;
					}

					// An <a> with no href is not focusable and reads as a link,
					// so make it behave like the button it looks like
					if (control.tagName === "A" && !control.getAttribute("href")) {
						control.setAttribute("role", "button");
						control.setAttribute("tabindex", "0");
					}

					accordion_toggle_all._sync(control, $details);

					$(control).on("click", function (e) {
						e.preventDefault();

						let allOpen = accordion_toggle_all._allOpen($details);

						$details.each(function () {
							// When all are open we click the open ones to close them.
							// When some are closed we click the closed ones to open them.
							if (this.open === allOpen) {
								this.querySelector("summary").click();
							}
						});

						// allOpen was read before the clicks fired, so it reflects
						// the state the user was leaving, not the one they landed on
						accordion_toggle_all._track({
							action: allOpen ? "collapse" : "expand",
							count: $details.length,
							scope: $scope,
						});
					});

					// Space and Enter on a role="button" element
					$(control).on("keydown", function (e) {
						if (e.key === " " || e.key === "Enter") {
							e.preventDefault();
							$(this).trigger("click");
						}
					});

					// The native toggle event fires when the Accordion class sets
					// el.open, and when the hash handler sets the attribute.
					// It does not bubble, so bind it on each details directly.
					$details.on("toggle", function () {
						accordion_toggle_all._sync(control, $details);
					});
				});
			},

			_allOpen: function ($details) {
				return $details.toArray().every(function (d) {
					return d.open;
				});
			},

			_sync: function (control, $details) {
				let allOpen = accordion_toggle_all._allOpen($details);

				control.setAttribute("aria-expanded", allOpen ? "true" : "false");
				control.textContent = allOpen
					? control.dataset.labelClose || accordion_toggle_all.labelClose
					: control.dataset.labelOpen || accordion_toggle_all.labelOpen;
			},

			// * Send the toggle-all interaction to GA4, via gtag if it is present
			// * and falling back to the dataLayer for GTM setups
			_track: function (data) {
				// Name the group so the report is readable when a page has
				// more than one accordion block
				let section =
					data.scope.attr && data.scope.attr("id")
						? data.scope.attr("id")
						: data.scope.find("h2").first().text().trim() || "unscoped";

				let payload = {
					toggle_action: data.action,
					accordion_count: data.count,
					page_section: section,
				};

				if (typeof window.gtag === "function") {
					window.gtag("event", "accordion_toggle_all", payload);
					return;
				}

				if (window.dataLayer) {
					window.dataLayer.push(
						$.extend({ event: "accordion_toggle_all" }, payload)
					);
				}
			},
		};

		accordion_toggle_all._init();
	});
})(window.jQuery, window, document);
